import { render, staticRenderFns } from "./orders-edit.vue?vue&type=template&id=b4ab3f16&scoped=true&"
import script from "./orders-edit.vue?vue&type=script&lang=ts&"
export * from "./orders-edit.vue?vue&type=script&lang=ts&"
import style0 from "./orders-edit.vue?vue&type=style&index=0&id=b4ab3f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ab3f16",
  null
  
)

export default component.exports